// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.carbonara-badge {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 3px;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
